import type {ReactNode} from 'react'

export function BloqueInterno({titulo, accion, children}: {titulo: string; accion?: ReactNode; children: ReactNode}) {
  return (
    <div className="surface-divider space-y-3 rounded-xl border border-dashed bg-secondary/30 p-4">
      <p className="flex items-center gap-1.5 font-mono text-[10px] font-semibold tracking-[0.12em] text-muted-foreground uppercase">
        {titulo}
        {accion}
      </p>
      {children}
    </div>
  )
}
